module.exports = __webpack_public_path__ + "img/coin.2f820c4e.svg";